<div class="progress-bar">
  <div class="header">
    <span class="title">{{ title }}</span>
    <span class="percents">{{ percents }}%</span>
  </div>

  <div class="bar">
    <div
      class="bar-filled"
      [ngClass]="{'completed': isCompleted}"
      [style.width]="percents + '%'"
    ></div>
  </div>
</div>
